module.exports = __webpack_public_path__ + "img/riskrate.4a409947.png";